import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMediaImages } from "../services/images.service";
import { QueryKeys } from "./queryKeys";

export const useDeleteImages = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ imageIds }: { imageIds: string[] }) => {
      const joinedImageIds = imageIds.join(",");
      return deleteMediaImages(joinedImageIds);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.ImagesByMedia],
      });
    },
  });
};
